<div class="flex flex-row col-12 grid grid-nogutter">
    <div class="col-12 sm:col-3">
        <form [formGroup]="templateForm">
            <div>
                <p-floatLabel>
                    <input type="subject" formControlName="subject" pInputText />
                    <label for="subject">Subject</label>
                </p-floatLabel>
            </div>
            <div class="mt-4">
                <p-floatLabel>
                    <textarea formControlName="content" rows="5" cols="30" pInputTextarea [autoResize]="true" [placeholder]="'Write Message...' | sentenceCase "></textarea>
                    <label>Message</label>
                </p-floatLabel>
            </div>
            <div>
                <p-button
                    label={{buttonText}}
                    size="large"
                    [disabled]="!templateForm.valid"
                    [rounded]="true"
                    (onClick)="onSubmit()"
                    styleClass="teal"
                    />
            </div>
        </form>
    </div>

    <div class="col-12 sm:col-8 mt-3 ml-2 sm:mt-0">
        <p-table styleClass="p-datatable-sm p-datatable-sm--normal" [value]="template" [paginator]="true" [rows]="5" [tableStyle]="{ 'min-width': '30rem' }"
        [showCurrentPageReport]="true" autoLayout="true" [scrollable]="true"
        currentPageReportTemplate="Showing {first} - {last} of {totalRecords}">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    Subject
                </th>
                <th>
                    Message
                </th>
                @if (helperService.checkResponsive()) {
                    <th alignFrozen="right" pFrozenColumn>
                      <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                    </th>
                    } @else {
                    <th>
                      <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                    </th>
                    }
                    <ng-template #frozenHeader>
                    Action
                    </ng-template>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-template>
            <tr>
                <td>{{ template.subject }}</td>
                <td>{{ template.content }}</td>
                @if (helperService.checkResponsive()) {
                    <td alignFrozen="right" pFrozenColumn>
                      <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                    </td>
                    } @else {
                    <td>
                      <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                    </td>
                    } 
                    <ng-template #frozenData>
                        <div class="wrap-actions">
                            <p-button pTooltip="Edit" tooltipPosition="top" [rounded]="true" [text]="true" icon="true" (click)="onEdit(template)">
                                <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                            </p-button>
                            <p-button (click)="onDelete(template)" pTooltip="Delete" tooltipPosition="top" [rounded]="true" [text]="true" icon="true">
                                <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                            </p-button>
                        </div>
                    </ng-template>
            </tr>
        </ng-template>
        </p-table>
    </div>
</div>

